import React, { useState } from 'react';
import axios from 'axios';


function PullOutTray({variationItems}) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false); // State to track the drawer open/close

  const handleAddToCart = async (sku) => {
    try {
      const url = new URL('https://buynow-dot-bold-sales-demos.uc.r.appspot.com/channel/youtube/initialize');
      url.searchParams.append('sku', sku);
      url.searchParams.append('quantity', 1);
      url.searchParams.append('videoId', 'PmsjR4608do');
  
      const response = await fetch(url);
  
      if (response.ok) {
        const data = await response.json();
        const { shopName, shopAlias, shopIdentifier, loginUrl, headerLogoUrl, checkout } = data;
  
        // Set the retrieved values in the window object
        window.shopName = shopName;
        window.shopAlias = shopAlias;
        window.shopIdentifier = shopIdentifier;
        window.loginUrl = loginUrl;
        window.headerLogoUrl = headerLogoUrl;
        window.environment = {
          type: 'production',
        };
        window.platformType = 'bigcommerce';
  
        // Send checkout data to the parent window
        window.parent.postMessage(
          {
            type: 'buyNow:open',
          },
          '*'
        );
        window.parent.postMessage(
          {
            type: 'buyNow:initialized',
            detail: JSON.parse(checkout),
          },
          '*'
        );
  
        setIsDrawerOpen(false);
      } else {
        throw new Error('Failed to fetch checkout data');
      }
    } catch (error) {
      console.error('Failed to fetch checkout data:', error);
    }
  };
  


  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <div className={`pull-out-tray ${isDrawerOpen ? 'open' : ''}`}>
      <button className="toggle-button" onClick={toggleDrawer}>
        {isDrawerOpen ? 'Close Drawer' : 'Open Drawer'}
      </button>
      {isDrawerOpen && (
        <div className="product-cards">
          {variationItems.map((variation) => (
            <div className="product-card" key={variation.product_id}>
              <img className="product-card__image" src={variation.product_image} alt={variation.product_name} />
              <h3>{variation.product_name}</h3>
              <p>{variation.product_price}</p>
              <button className="product-card__button" onClick={() => handleAddToCart(variation.product_sku)}>Add to Cart</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default PullOutTray;
